import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl, intlShape } from '../../util/reactIntl';
import { isScrollingDisabled } from '../../ducks/UI.duck';
import { TopbarContainer } from '../../containers';
import {
  PageBootstrap,
  Footer,
} from '../../components';
import config from '../../config';
import "./privacypolicypage.scss"
import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import metaImage from '../../assets/ogp.jpg';

const PrivacyPolicyPageComponent = props => {
  const { scrollingDisabled, intl } = props;

  const siteTitle = config.siteTitle;
  const schemaTitle = intl.formatMessage({ id: 'PrivacyPolicyPage.schemaTitle' }, { siteTitle });
  const schemaDescription = intl.formatMessage({ id: 'PrivacyPolicyPage.schemaDescription' });
  const schemaImage = `${config.canonicalRootURL}${metaImage}`;
  return (

    <PageBootstrap
    //description={schemaDescription}
    title={schemaTitle}
    facebookImages={[{ url: metaImage, width: 1200, height: 630 }]}
    twitterImages={[{ url: `${config.canonicalRootURL}${metaImage}`, width: 600, height: 314 }]}
    schema={{
      '@context': 'http://schema.org',
      '@type': 'PrivacyPolicyPage',
      description: schemaDescription,
      name: schemaTitle,
      image: [schemaImage],
    }}
  >
    <TopbarContainer />
    <nav className="secondbar">
      <Row className="inner d-flex flex-row">
        <Col lg="auto" md="auto" sm="auto" xs="auto">
          <p className="page-title align-items-center justify-content-start">
              Privacy Policy
          </p>
        </Col>
      </Row>
    </nav>

    <Container fluid className="content">
      <Row>
        <Col>
          <h1 className="title mb-3 mt-5">Kammuiプライバシーポリシー</h1>
        </Col>
      </Row>
      
      <Row>
        <Col>
          <p className="infoText mb-3">株式会社KAMMUI（以下「当社」といいます。）は、当社が提供する「Kammui.com」ポータルサイトサービス（以下、「本サービス」といいます。）における個人情報の取扱いについて、下記のとおり個人情報保護方針（以下、「本プライバシーポリシー」といいます。）を定め、「個人情報の保護に関する法律」平成15年法律第57号（以下、｢個人情報保護法｣といいます。）及び個人情報保護委員会が定めるガイドラインその他の関係法令とともに、これを遵守します。
          </p>
        </Col>
      </Row>

      <Row>
        <Col>
          <p className="infoTitleText mt-4">第1条	個人情報の取得と利用</p>
          <p className="infoText mb-3">当社は、本プライバシーポリシーに記載する利用目的の達成に必要な範囲で、個人情報を適法かつ公正な手段によって取得し利用いたします。
          </p>
        </Col>
      </Row>

      <Row>
        <Col>
          <p className="infoTitleText mt-4">第2条	個人情報</p>
          <p className="infoText mb-3">「個人情報」とは、個人情報保護法における「個人情報」を指すものとし、生存する個人に関する情報であって、当該情報に含まれる氏名、生年月日、住所、電話番号、メールアドレス、又は音声、動作その他の方法により特定の個人を識別できるもの（他の情報と容易に照合することで特定の個人を識別できるものを含む）を指します。</p>
          <p className="infoText mb-3">なお、個人情報保護法における「個人識別符号」も含まれ、運転免許証番号や健康保険証の保険者番号などの当該情報単体から特定の個人を識別できる情報を指します。</p>

          <p className="infoText mb-3">本プライバシーポリシーにおいて、「個人情報」の中に「要配慮個人情報」が含まれるとし、個人情報保護法およびガイドライン等において要配慮個人情報について特別の定めがある場合は、当社はそれらに従います。「要配慮個人情報」には、身体障害、知的障害、精神障害（発達障害を含む）等の障害があること、健康診断その他の検査の結果等が該当します。</p>

          <p className="infoText mb-3">当社は本サービスを提供する上で、以下の個人情報を取得します。なお、ご利用者が本サービスを利用するために代理で本サービスの利用に申し込む方がいる場合は、当該代理者の個人情報も含まれる場合があります。</p>
          <p className="infoTextIndented mb-3">
            1	氏名、住所、生年月日、性別、メールアドレス、電話番号<br />
            2	端末情報（位置情報、端末の機体識別情報、OS情報、IPアドレス等）<br />
            3	行動履歴情報およびCookie<br />
            4	クレジットカード番号および本サービスの決済に関する情報<br />
            5	その他、本サービスを利用するために当社が必要と判断し要求する情報
          </p>
        </Col>
      </Row>

      <Row>
        <Col>
          <p className="infoTitleText mt-4">第3条	個人情報の利用目的</p>
          <p className="infoText mb-3">当社は、ご利用者および当社ポータルサイトに登録するパートナーを対象として個人情報を取得しますが、以下の目的を超えて利用することはありません。</p>

          <p className="infoText mb-3">（１）ご利用者に関する個人情報の利用目的</p>
          <p className="infoTextIndented mb-3">
            1	本サービスの利用開始時の登録のため<br />
            2	本サービスを利用する上での本人確認のため<br />
            3	本サービスの提供、改善、新機能の開発のため<br />
            4	本サービスの利用状況の把握・分析のため<br />
            5	本サービス運営に必要な事項の通知のため<br />
            6	不正行為、セキュリティや技術上の問題に関して、その検出や阻止その他の対処を講じるため<br />
            7	本サービスに対する問い合わせ対応のため<br />
            8	本サービス利用するために必要な、決済代行会社、金融機関やクレジットカード会社等、または提携企業への情報提供のため<br />
            9	当社及びパートナーのサービス、キャンペーン情報等を配信および広告提供やアンケート実施のため<br />
            10	利用履歴の情報を分析して、趣味・嗜好に応じたサービスに関する広告のために利用するため<br />
            11	不正利用に対応するため<br />
            12	利用者間のトラブルまたはパートナーとのトラブルを解決するためその他、上記利用目的に付随する目的のため本人確認および不正利用の防止のため<br />
            13	サービス利用状況の確認のため<br />
            14	電子メールやSNS等による広告・情報提供、およびアンケートの実施のため
          </p>

          <p className="infoText mb-3">（２）当社の提携パートナーおよび決済代行会社やその他取引先に関する個人情報の利用目的</p>
          <p className="infoTextIndented mb-3">
            1	本サービスを提供するための情報の連携のため<br />
            2	本サービスを提供するために締結されている契約の履行等のため<br />
            3	取引先情報の管理のため
          </p>
        </Col>
      </Row>

      <Row>
        <Col>
          <p className="infoTitleText mt-4">第4条	Cookieについて</p>
          <p className="infoText mb-3">当社は、Cookie および行動履歴情報（以下、「Cookie等」といいます。）を利用して、広告配信、プライバシー保護、利便性の向上、利用規約に違反している利用者の発見、サービス等を悪用した詐欺や不正アクセス等の検知を行い、またCookie 等をGoogle Analyticsに提供し、統計データの取得（特定の個人を識別する情報は一切含まれません）をします。</p>

          <p className="infoText mb-3">また、当社の保有する個人情報と第三者広告配信事業者が保有する個人情報を、本人が特定されないデータに不可逆変換した上で第三者広告配信事業者においてマッチングを行い、その結果に基づいて広告を配信することがあります。</p>

          <p className="infoText mb-3">なお、以下の第三者広告配信事業者については、Cookie等を使用して、本サービスへのアクセス情報をもとに広告を配信する場合がありますが、Cookie等には特定の個人を識別する情報は一切含まれておらず、広告配信のみに利用されます。</p>

          <p className="infoText mb-3">ご利用者がCookieによる情報取得の停止を希望する場合には以下のリンクからそれぞれの事業者において当該事業者によるCookieの使用を無効にするオプトアウトの手続きをおこなってください。なお、オプトアウトがなされた場合は、本サービスが意図された通りに機能しない場合があります。</p>

          <p className="infoText mb-3">
            Google&nbsp;（<a className="infotextlink" href={"https://support.google.com/ads/answer/2662922?hl=ja"} target={"_blank"}>https://support.google.com/ads/answer/2662922?hl=ja</a>）<br />
            Yahoo! JAPAN&nbsp;（<a className="infotextlink" href={"http://btoptout.yahoo.co.jp/optout/index.html"} target={"_blank"}>http://btoptout.yahoo.co.jp/optout/index.html</a>）<br />
            Facebook&nbsp;（<a className="infotextlink" href={"https://www.facebook.com/about/ads"} target={"_blank"}>https://www.facebook.com/about/ads</a>）<br />
            Twitter&nbsp;（<a className="infotextlink" href={"https://support.twitter.com/articles/20171553"} target={"_blank"}>https://support.twitter.com/articles/20171553</a>）<br />
          </p>
        </Col>
      </Row>

      <Row>
        <Col>
          <p className="infoTitleText mt-4">第5条	個人情報の共同利用について</p>
          <p className="infoText mb-3">当社は、ご利用者の個人情報の共同利用を行っておりません。</p>
        </Col>
      </Row>

      <Row>
        <Col>
          <p className="infoTitleText mt-4">第6条	個人情報の第三者提供について</p>
          <p className="infoText mb-3">当社は、以下のいずれかに該当する場合を除き、ご利用者または当社提携先からお預かりした個人情報を第三者に提供いたしません。なお、個人情報保護法において、委託先、営業譲渡先、または共同利用先への提供は、第三者提供にはあたりません。</p>

          <p className="infoTextIndented mb-3">
            1	ご本人から事前にご同意をいただいた場合<br />
            2	利用目的の達成に必要な範囲内において委託した場合<br />
            3	法令に基づき提供を求められた場合<br />
            4	人の生命、身体または財産の保護のために必要な場合であって、ご本人の同意を得ることが困難である場合<br />
            5	公衆衛生の向上または児童の健全な育成の推進のために特に必要がある場合であって、ご本人の同意を得ることが困難である場合<br />
            6	国または地方公共団体などが法令の定める事務を実施するうえで、協力する必要がある場合であって、ご本人の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがある場合<br />
            7	共同利用者の範囲に掲げる者に対して提供する場合<br />
          </p>
        </Col>
      </Row>

      <Row>
        <Col>
          <p className="infoTitleText mt-4">第8条	安全管理措置に関する事項</p>
          <p className="infoText mb-3">当社は、個人情報の管理のために必要かつ適切な安全管理措置を講じます。また、個人情報を取り扱う従業者や委託先（再委託先等を含みます。）に対して、必要かつ適切な監督を行います。</p>
        </Col>
      </Row>

      <Row>
        <Col>
          <p className="infoTitleText mt-4">第9条	外国における個人情報の取扱いがないこと</p>
          <p className="infoText mb-3">当社は外国事業者に対して、当社の業務を一部委託契約により委託し、氏名、メールアドレス等の必要な個人情報を提供する場合があり、その場合には、提供・委託先の具体的な国・地域名や個人情報保護制度に関する情報を、当社ホームページで開示します。</p>

          <p className="infoText mb-3">なお、その場合には、以下を遵守できる海外委託先を選択するものとします。</p>
          <ul className="infoTextIndented mb-3">
            <li>当社から委託された業務を遂行する目的の範囲で個人情報を取り扱います。</li>
            <li>適用のある現地法を遵守しています。</li>
            <li>OECDプライバシーガイドライン８原則に対応する措置をすべて講じています。</li>
            <li>概ね個人データの取扱いについて我が国の個人情報取扱事業者に求められる措置と同水準の措置を講じています。当社は、個人情報を外国において管理したり、外国にある委託先に委託しておりません。</li>
          </ul>

          <p className="infoTitleText mt-4">第10条	個人情報の開示等の請求</p>
          <p className="infoText mb-3">当社では、当社が保有する個人情報に関して、ご本人またはその代理人からの以下いずれかの開示請求をメールまたは書面にて受領した場合、個人情報保護法に基づき適切に対応いたします。</p>
          <p className="infoTextIndented mb-3">
            1	個人情報の利用目的を通知する旨の請求<br />
            2	当社が保有している個人情報の内容についての開示請求<br />
            3	個人情報の内容が事実でないときは、内容の訂正、追加または削除の請求<br />
            4	個人情報が利用目的の範囲を超えて取り扱われているときは、利用の停止または消去の請求<br />
            5	個人情報が法令に違反して第三者に提供されているときは、第三者への提供の停止の請求<br />
          </p>
        </Col>
      </Row>

      <Row>
        <Col>
          <p className="infoTitleText mt-4">第11条	個人情報の訂正等</p>
          <p className="infoText mb-3">当社は、個人情報の内容が不正確である理由により、その内容の訂正、追加又は削除（以下「訂正等」といいます。）を求められた場合には、ご本人からのご請求であることを確認の上で、利用目的の達成に必要な範囲内において、遅滞なく必要な調査を行い、その結果に基づき、個人情報の内容の訂正等を行い、その旨を通知します（訂正等を行わない旨の決定をしたときは、その旨を通知いたします。）。但し、個人情報保護法その他の法令により、当社が訂正等の義務を負わない場合は、この限りではありません。</p>
        </Col>
      </Row>

      <Row>
        <Col>
          <p className="infoTitleText mt-4">第12条	個人情報の利用停止等・第三者提供の停止</p>
          <p className="infoText mb-3">当社は、当社保有の個人情報が①あらかじめ公表された利用目的の範囲を超えて取扱われているという理由②不正の手段により取得されたものであるという理由③不適正な利用が行われているものであるという理由④当社が利用する必要がなくなったという理由⑤個人情報保護委員会への報告対象となる重大な漏えい等が生じたという理由⑥その他本人が識別される個人情報の取扱いにより、本人の権利または正当な利益が害されるおそれがあるという理由において、個人情報の利用の停止又は消去（以下「利用停止等」といいます。）を求められた場合、又は個人情報がご本人の同意なく第三者に提供されているという理由若しくは上記④⑤⑥の理由により、提供の停止（以下「提供停止」といいます。）を求められた場合において、そのご請求に理由があることが判明した場合には、お客さまご本人からのご請求であることを確認の上で、遅滞なく個人情報の利用停止等又は提供停止を行い、その旨をお客さまに通知します。但し、個人情報保護法その他の法令により、当社が利用停止等又は提供停止の義務を負わない場合は、この限りではありません。</p>
        </Col>
      </Row>

      <Row>
        <Col>
          <p className="infoTitleText mt-4">第13条	プライバシーポリシーの変更</p>
          <p className="infoText mb-3">当社は、個人情報保護法の範囲内でプライバシーポリシーを変更することがあります。その場合は、ウェブサイト等にて開示するものとします。</p>
        </Col>
      </Row>

      <Row>
        <Col>
          <p className="infoTitleText mt-4">第14条	お問い合わせ窓口</p>
          <p className="infoText mb-3">皆様からお預かりしている個人情報については、利用目的の通知、開示、訂正等、利用停止等又は第三者提供の停止の要求が可能です。具体的な方法については、下記までお問い合わせください。</p>
          <p className="infoText mb-3">本人確認書類　当社所定の本人確認書類を添付<br />
            開示・利用目的通知　請求費用　一件あたり2,000円<br />
            宛先　株式会社KAMMUI 個人情報保護相談窓口<br />
            メールアドレス　<a href={"mailto:legal@kammui.com"} className="infotextlink" target={"_blank"}>legal@kammui.com</a></p>
          <p className="updatedTime">2022年　8月　1日 制定</p>
        </Col>
      </Row>
      <p className="separator" />

      <Row>
        <Col>
          <h1 className="title mb-3 mt-5">特定商取引法に基づく表記</h1>
        </Col>
      </Row>

      <Row>
        <Col>
          <p className="infoTitleText mt-4">代表責任者</p>
          <p className="infoText mb-3">Maximilian Mackee</p>
        </Col>
      </Row>

      <Row>
        <Col>
          <p className="infoTitleText mt-4">会社名</p>
          <p className="infoText mb-3">株式会社KAMMUI</p>
        </Col>
      </Row>

      <Row>
        <Col>
          <p className="infoTitleText mt-4">所在地</p>
          <p className="infoText mb-3">153-0042 東京都目黒区青葉台3-12-3</p>
        </Col>
      </Row>

      <Row>
        <Col>
          <p className="infoTitleText mt-4">連絡先</p>
          <p className="infoText mb-3">メール&nbsp;&nbsp;&nbsp;&nbsp;<a href={"mailto:legal@kammui.com"} className="infotextlink" target={"_blank"}>legal@kammui.com</a><br />
            電話&nbsp;&nbsp;&nbsp;&nbsp;※お電話でのサポートは原則行なっておりません。</p>
        </Col>
      </Row>
      <Row>
        <Col>
          <p className="infoTitleText mt-4">販売価格</p>
          <p className="infoText mb-3">予約申込等の際に、当社ポータルサイト画面に表示します。</p>
        </Col>
      </Row>

      <Row>
        <Col>
          <p className="infoTitleText mt-4">販売価格以外にお客様にご負担いただく金銭</p>
          <p className="infoText mb-3">電気通信回線の通信料金等(インターネット接続料金を含む)<br />なお、通信料金等はお客様がご利用のインターネットプロバイダー又は携帯電話会社にお問い合わせください。</p>
        </Col>
      </Row>

      <Row>
        <Col>
          <p className="infoTitleText mt-4">販売価格以外にお客様にご負担いただく金銭</p>
          <p className="infoText mb-3">電気通信回線の通信料金等(インターネット接続料金を含む)<br />なお、通信料金等はお客様がご利用のインターネットプロバイダー又は携帯電話会社にお問い合わせください。</p>
        </Col>
      </Row>
      <Row>
        <Col>
          <p className="infoTitleText mt-4">お支払い方法</p>
          <p className="infoText mb-3">クレジットカードや銀行振込によるオンライン決済</p>
        </Col>
      </Row>
      <Row>
        <Col>
          <p className="infoTitleText mt-4">提供時期</p>
          <p className="infoText mb-3">お支払手続完了後、予約をいただいた日に提供いたします。</p>
        </Col>
      </Row>
      <Row>
        <Col>
          <p className="infoTitleText mt-4">キャンセルについて</p>
          <p className="infoText mb-3">当社キャンセルポリシーを参照ください。</p>
        </Col>
      </Row>
      <Row>
        <Col>
          <p className="infoTitleText mt-4">動作環境</p>
          <p className="infoText mb-3">最新の動作環境は、ご利用ガイド内の動作環境のページに記載しております。</p>
        </Col>
      </Row>
    </Container>

    <Footer showBanner={false} />

    </PageBootstrap>
  );
};

const { bool } = PropTypes;

PrivacyPolicyPageComponent.propTypes = {
  scrollingDisabled: bool.isRequired,

  // from injectIntl
  intl: intlShape.isRequired,
};

const mapStateToProps = state => {
  return {
    scrollingDisabled: isScrollingDisabled(state),
  };
};

const PrivacyPolicyPage = compose(
  connect(mapStateToProps),
  injectIntl
)(PrivacyPolicyPageComponent);

export default PrivacyPolicyPage;
